import React, { FC, useLayoutEffect, useRef } from 'react'

import { errorNotificationDataHooks as dataHooks } from './ErrorNotification.dataHooks'
import { useErrorNotification } from './ErrorNotificationContext'

export const ErrorNotificationOutlet: FC = () => {
  const { registerOutlet } = useErrorNotification()
  const outletRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => registerOutlet(outletRef.current), [registerOutlet])

  return <div ref={outletRef} data-hook={dataHooks.outlet()} />
}
